import styled from 'styled-components';

import {
    IconExternal,
    Text,
    spaceMixin,
    token,
} from '@zillow/constellation';

export const StyledStatisticsComponent = styled.div`
    flex-grow: 3;
    min-height: 140px;
    text-align: center;
    overflow: hidden;
`;

export const StyledBarChartContainer = styled.div`
    .ResponsiveContainer-BarChart {
        margin-bottom: ${spaceMixin('xs')};
        height: 70px !important;
        pointer-events: none;
    }
`;

export const StyledTitle = styled(Text)`
    margin-bottom: ${spaceMixin('xs')};
`;

export const StyledChartRow = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
`;

export const StyledIconExternal = styled(IconExternal)`
    color: ${token('colors.blue400')};
`;
